import React, {Component} from 'react';
import Options from './Options';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {fetchCapabilityCallSuccess, fetchCycles, navigationRemoved, viewChanged} from "../actions/OptionsActions";
import Cluster from "./Cluster";
import Aisle from "./Aisle";
import Floor from "./floor/Floor";
import SortZone from "./SortZone";
import Column from "@amzn/meridian/column";
import Breadcrumb from "@amzn/meridian/breadcrumb";
import BreadcrumbGroup from "@amzn/meridian/breadcrumb/breadcrumb-group";
import Box from "@amzn/meridian/box";
import CycleOptions from "./options/CycleOptions";
import {
    getInductPackageMetricsForCluster,
    getStowAssociateMetricsForCluster,
    getStowBinMetricsForCluster,
    getStowCartMetricsForCluster,
    getStowPackageMetricsForCluster
} from "../actions/ClusterActions";
import {
    getInductPackageMetricsForAisle,
    getStowAssociateMetricsForAisle,
    getStowBagMetricsForAisle,
    getStowBinMetricsForAisle,
    getStowCartMetricsForAisle,
    getStowPackageMetricsForAisle
} from "../actions/AisleActions";
import {
    fetchOvUsageForSortZone,
    getInductPackageMetricsForSortZone,
    getStowBagMetricsForSortZone,
    getStowPackageMetricsForSortZone
} from "../actions/SortZoneActions";
import {getNodeId, extractRouteCodePrefixesFromParam, isOnlyRouteViewApplicable} from "../Utility";
import StationPair from "./station-pair/StationPair";
import {
    getInductPackageMetricsForStationPair,
    getPickPackageMetricsForStationPair,
    getStowAssociateMetricsForStationPair,
    getStowFloorMetricsForStationPair,
    getStowPackageMetricsForStationPair
} from "../actions/StationPairActions";
import {
    getInductPackageMetricsForFloor,
    getPickPackageMetricsForFloor,
    getStowFloorDataForFloor,
    getStowPackageMetricsForFloor
} from "../actions/FloorActions";
import {FEATURES, OPTIONS_TAG_REQUIRED, HEADERS, refreshInterval} from "../constants";
import {Capability, HeatMapView, ViewType} from "../enums";
import Route from "./Route";
import HeatMapViewOptions from "./options/HeatMapViewOptions";
import {getMetricsForRoute} from "../actions/RouteActions";
import {getFeaturesFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {
    getStowAssociateMetricsForZone,
    getStowPackageMetricsForZone
} from "../actions/ZoneActions";
import Zone from "./Zone";
import CartLocation from "./CartLocation";
import {
    getStowFloorDataForCartLocation,
    getStowPackageMetricsForCartLocation
} from "../actions/CartLocationActions";
import {fetchFeatureStatusCallSuccess} from "../actions/ConfigActions";
import {PageHeader} from "./utils/PageHeader";
import FloorLocation from "./sideline/FloorLocation";
import {
    getStowFloorMetricsForFloorLocation,
    getStowPackageMetricsForFloorLocation
} from "../actions/FloorLocationActions";
import Cart from "./sideline/Cart";
import {getStowPackageMetricsForCart} from "../actions/CartActions";

class HeatMap extends Component {


    constructor(props) {
        super(props);
        this.state = {
            nodeId: getNodeId(),
            routeCodePrefixes: extractRouteCodePrefixesFromParam(props)
        };
    }

    timer;

    render() {
        const {navigationOptions, selectedCycle, selectedCycleId, selectedView, isInitialView} = this.props;
        //For initial view open route view when route code prefix list exists in params
        if (this.state.routeCodePrefixes && this.state.routeCodePrefixes !== "" && isInitialView) {
            this.props.dispatch(viewChanged(HeatMapView.ROUTE_VIEW))
        }
        const view = this.findViewByOptionValues(navigationOptions, selectedView);

        const renderSubComponent = () => {

            clearInterval(this.timer);

            switch (view) {
                case HeatMapView.AISLE_VIEW:
                    return this.renderAisleView(selectedCycle, selectedCycleId)
                case HeatMapView.SORT_ZONE_VIEW:
                    return this.renderSortZoneView(selectedCycle, selectedCycleId)
                case HeatMapView.STATION_PAIR_VIEW:
                    return this.renderStationPairView()
                case HeatMapView.FLOOR_VIEW:
                    return this.renderFloorView()
                case HeatMapView.ROUTE_VIEW:
                    return this.renderRouteView(this.state.routeCodePrefixes)
                case HeatMapView.ZONE_VIEW:
                    return this.renderZoneView(selectedCycle, selectedCycleId)
                case HeatMapView.CART_LOCATION_VIEW:
                    return this.renderCartLocationView()
                case HeatMapView.FLOOR_LOCATION_VIEW:
                    return this.renderFloorLocationView()
                case HeatMapView.CART_VIEW:
                    return this.renderCartView()
                case HeatMapView.CLUSTER_VIEW:
                default:
                    return this.renderClusterView(selectedCycle, selectedCycleId)
            }
        }

        const navigationChanged = navigationIndex => {
            this.props.dispatch(navigationRemoved(navigationIndex));
        }

        function renderBreadCrumb(navigationOptions) {
            if (navigationOptions.length) {
                return (
                    <Box spacingInset="small none">
                        <BreadcrumbGroup>
                            <Breadcrumb onClick={() => navigationChanged(0)}>
                                Stow
                            </Breadcrumb>
                            {navigationOptions.map((navigationOption, index) => (
                                <Breadcrumb onClick={() => navigationChanged(index + 1)} key={navigationOption.key}>
                                    {navigationOption.key} {getNavigationOptionValue(navigationOption)}
                                </Breadcrumb>
                            ))}
                        </BreadcrumbGroup>
                    </Box>
                )
            }
        }

        const getNavigationOptionValue = (navigationOption) => {
            switch (this.props.capability) {
                case Capability.SSD:
                case Capability.AR_NEXT_GEN:
                    return navigationOption.displayValue;
                case Capability.AMZL:
                    return (navigationOption.displayValue ? navigationOption.displayValue : navigationOption.value);
                default:
                    return navigationOption.value;
            }
        }

        return (
            <Column spacingInset="small large">
                <PageHeader {...HEADERS.HEATMAP}/>
                {this.renderOptions(selectedView)}
                {renderBreadCrumb(navigationOptions)}
                <Box>{renderSubComponent()}</Box>
            </Column>
        )

    }

    renderOptions(selectedView) {
        return !isOnlyRouteViewApplicable(this.state.nodeId, this.props.capability)
            && <Options options={this.getApplicableOptions(selectedView)} optionsTagsRequired={this.getApplicableOptionTags(selectedView)}/>
    }

    getApplicableOptions(selectedView) {
        if (ViewType.ROUTE_VIEW === selectedView || ViewType.SIDELINE_VIEW === selectedView || Capability.AR_NEXT_GEN === this.props.capability)
            return [{component: <HeatMapViewOptions/>, name: "HeatMapViewOptions"}]
        else
            return [{component: <HeatMapViewOptions/>, name: "HeatMapViewOptions"}, {component: <CycleOptions/>, name: "CycleOptions"}]
    }

    getApplicableOptionTags(selectedView) {
        if (ViewType.ROUTE_VIEW === selectedView || ViewType.SIDELINE_VIEW === selectedView || Capability.AR_NEXT_GEN === this.props.capability)
            return []

        return OPTIONS_TAG_REQUIRED
    }

    renderAisleView(selectedCycle, selectedCycleId) {
        this.fetchAisleData(this.state.nodeId, selectedCycle, this.getViewSubjects('Cluster'), selectedCycleId);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchAisleData(this.state.nodeId, selectedCycle, this.getViewSubjects('Cluster'), selectedCycleId)
            }
        }, refreshInterval);
        return <Aisle/>
    }

    renderSortZoneView(selectedCycle, selectedCycleId) {
        this.fetchSortZoneData(this.state.nodeId, selectedCycle, this.getViewSubjects('Aisle'), selectedCycleId);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchSortZoneData(this.state.nodeId, selectedCycle, this.getViewSubjects('Aisle'), selectedCycleId)
            }
        }, refreshInterval);
        return <SortZone/>
    }

    renderClusterView(selectedCycle, selectedCycleId) {
        this.fetchClusterData(this.state.nodeId, selectedCycle, selectedCycleId);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchClusterData(this.state.nodeId, selectedCycle, selectedCycleId)
            }
        }, refreshInterval);
        return <Cluster/>
    }

    renderFloorLocationView() {
        this.fetchFloorLocationData(this.state.nodeId);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchFloorLocationData(this.state.nodeId);
            }
        }, refreshInterval);
        return <FloorLocation/>
    }

    renderCartView() {
        this.fetchCartData(this.state.nodeId, ...this.getViewSubjects('Floor Location, Re-Induct Day'));
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchCartData(this.state.nodeId, ...this.getViewSubjects('Floor Location, Re-Induct Day'))
            }
        }, refreshInterval);
        return <Cart/>
    }

    renderZoneView(selectedCycle, selectedCycleId) {
        this.fetchZoneData(this.state.nodeId, selectedCycle, selectedCycleId);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchZoneData(this.state.nodeId, selectedCycle, selectedCycleId)
            }
        }, refreshInterval);
        return <Zone/>
    }

    renderRouteView(routeCodePrefixes) {
        this.fetchRouteData(this.state.nodeId, this.props.capability);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchRouteData(this.state.nodeId, this.props.capability)
            }
        }, refreshInterval);
        return <Route routeCodePrefixesFromUrl={routeCodePrefixes}/>
    }

    renderFloorView() {
        this.fetchFloorData();
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchFloorData()
            }
        }, refreshInterval);
        return <Floor nodeId={this.state.nodeId}/>
    }

    renderCartLocationView() {
        this.fetchCartLocationData();
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchCartLocationData()
            }
        }, refreshInterval);
        return <CartLocation nodeId={this.state.nodeId} featureStatus={this.props.featureStatus} />
    }

    renderStationPairView() {
        this.fetchStationPairData();
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchStationPairData()
            }
        }, refreshInterval);
        return <StationPair/>
    }

    getViewSubjects = (key) => (
        this.props.navigationOptions
            .filter((navigationOption) => navigationOption.key === key)
            .map(navigationOption => navigationOption.value)
    );

    fetchClusterData(nodeId, cycle, cycleId) {
        if (cycle && cycleId && this.props.featureStatus) {
            this.props.dispatch(getStowPackageMetricsForCluster(this.props.featureStatus[FEATURES.ADTA_VISIBILITY],
                this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY],
                nodeId, [cycle], [cycleId]));
            this.props.dispatch(getStowBinMetricsForCluster(nodeId, [cycle], [cycleId]));
            this.props.dispatch(getInductPackageMetricsForCluster(nodeId, [cycle]));
            this.props.featureStatus[FEATURES.CART_VISIBILITY] &&
            this.props.dispatch(getStowCartMetricsForCluster(nodeId, [cycle], [cycleId]))
            this.props.dispatch(getStowAssociateMetricsForCluster(nodeId, [cycle]));
        }
    }

    fetchFloorLocationData(nodeId) {
        this.props.dispatch(getStowPackageMetricsForFloorLocation(nodeId, this.props.featureStatus));
        this.props.dispatch(getStowFloorMetricsForFloorLocation(nodeId, this.props.featureStatus));
    }

    fetchCartData(nodeId, floorLocationAndReInductDay) {
        this.props.dispatch(getStowPackageMetricsForCart(nodeId, this.props.featureStatus, ...floorLocationAndReInductDay));
    }

    fetchRouteData(nodeId, capability) {
        this.props.dispatch(getMetricsForRoute(nodeId, capability))
    }

    fetchAisleData(nodeId, cycle, clusters, cycleId) {
        if (cycle && cycleId && this.props.featureStatus) {
            this.props.dispatch(getStowPackageMetricsForAisle(this.props.featureStatus[FEATURES.ADTA_VISIBILITY],
                this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY], nodeId, [cycle], clusters, [cycleId]));
            this.props.dispatch(getStowBinMetricsForAisle(nodeId, [cycle], clusters, [cycleId]));
            this.props.dispatch(getStowBagMetricsForAisle(nodeId, [cycle], clusters, [cycleId]));
            this.props.featureStatus[FEATURES.CART_VISIBILITY] &&
            this.props.dispatch(getStowCartMetricsForAisle(nodeId, [cycle], clusters, [cycleId]));
            this.props.dispatch(getInductPackageMetricsForAisle(nodeId, [cycle], clusters));
            this.props.dispatch(getStowAssociateMetricsForAisle(nodeId, [cycle], clusters));
        }
    }

    fetchSortZoneData(nodeId, cycle, aisles, cycleId) {
        if (cycle && cycleId) {
            this.props.dispatch(getStowPackageMetricsForSortZone(this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY],
                nodeId, [cycle], aisles, [cycleId]));
            this.props.dispatch(getStowBagMetricsForSortZone(nodeId, [cycle], aisles, [cycleId]));
            this.props.dispatch(getInductPackageMetricsForSortZone(nodeId, [cycle], aisles));
            this.props.dispatch(fetchOvUsageForSortZone(nodeId, [cycle], aisles));
        }
    }

    fetchStationPairData() {
        const nodeId = this.state.nodeId
        this.props.dispatch(getInductPackageMetricsForStationPair(nodeId));
        this.props.dispatch(getPickPackageMetricsForStationPair(nodeId));
        this.props.dispatch(getStowAssociateMetricsForStationPair(nodeId));
        this.props.dispatch(getStowFloorMetricsForStationPair(nodeId));
        this.props.dispatch(getStowPackageMetricsForStationPair(nodeId));
    }

    fetchFloorData() {
        const nodeId = this.state.nodeId
        const stationPairs = this.getViewSubjects('Station')
        this.props.dispatch(getInductPackageMetricsForFloor(nodeId, stationPairs));
        this.props.dispatch(getPickPackageMetricsForFloor(nodeId, stationPairs));
        this.props.dispatch(getStowPackageMetricsForFloor(nodeId, stationPairs));
        this.props.dispatch(getStowFloorDataForFloor(nodeId, stationPairs));
    }

    fetchCartLocationData() {
        const nodeId = this.state.nodeId
        const zone = this.getViewSubjects('Zone')
        this.props.dispatch(getStowPackageMetricsForCartLocation(nodeId, zone));
        this.props.dispatch(getStowFloorDataForCartLocation(
            nodeId, 
            zone, 
            this.props.featureStatus[FEATURES.ROUTE_CODE_VISIBILITY]
        ));    
    }

    fetchZoneData(nodeId, cycle, cycleId) {
        if (cycle && cycleId) {
            this.props.dispatch(getStowPackageMetricsForZone(nodeId, [cycle], [cycleId]));
            this.props.dispatch(getStowAssociateMetricsForZone(nodeId, [cycle]));
        }
    }
    async componentDidMount() {
        try {
            const featureResponse = await getFeaturesFromParent([
                FEATURES.CART_VISIBILITY,
                FEATURES.ADTA_VISIBILITY,
                FEATURES.DRS_STOW_VISIBILITY,
                FEATURES.SIDELINE_STOW_VISIBILITY,
                FEATURES.SIDELINE_STOW_V2,
                FEATURES.REINDUCT_DATE_PLUS_ONE_FIX,
                FEATURES.ROUTE_CODE_VISIBILITY,
                FEATURES.DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY
            ]);
            this.props.dispatch(fetchFeatureStatusCallSuccess(featureResponse.data));
        } catch (error) {
            console.error('Error loading features:', error);
        }

        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = JSON.parse(capabilityResponse.capability);
            if (Capability.AR_NEXT_GEN !== capability) {
                this.props.dispatch(fetchCycles());
            }
            this.props.dispatch(fetchCapabilityCallSuccess(capabilityResponse));
        })
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    findViewByOptionValues = (navigationOptions, selectedView) => {
        switch (this.props.capability) {
            case Capability.SSD:
                return this.findViewForSSD(navigationOptions, selectedView)
            case Capability.AMZL:
            default:
                return this.findViewForAmzlCore(navigationOptions, selectedView);
            case Capability.AR_NEXT_GEN:
                return this.findViewForArNextGen(navigationOptions, selectedView);
        }
    }

    findViewForAmzlCore = (navigationOptions, selectedView) => {
        if (ViewType.SIDELINE_VIEW === selectedView) {
            if (navigationOptions.length === 1) return HeatMapView.CART_VIEW;
            return HeatMapView.FLOOR_LOCATION_VIEW;
        }
        if (isOnlyRouteViewApplicable(this.state.nodeId, this.props.capability) || ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        else if (navigationOptions.length === 2) return HeatMapView.SORT_ZONE_VIEW;
        else if (navigationOptions.length === 1) return HeatMapView.AISLE_VIEW;
        else return HeatMapView.CLUSTER;
    }

    findViewForSSD = (navigationOptions, selectedView) => {
        if (ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        if(navigationOptions.length === 1) return HeatMapView.CART_LOCATION_VIEW
        return HeatMapView.ZONE_VIEW
    }

    findViewForArNextGen = (navigationOptions, selectedView) => {
        if (ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        if (navigationOptions.length === 1) return HeatMapView.FLOOR_VIEW;
        else return HeatMapView.STATION_PAIR_VIEW;
    }
}

const mapStateToProps = state => ({
    capability: state.optionsReducer.capability,
    navigationOptions: state.optionsReducer.navigationOptions,
    selectedCycle: state.optionsReducer.options.cycle,
    selectedView: state.optionsReducer.heatMapView,
    selectedCycleId: state.optionsReducer.options.cycleId,
    featureStatus: state.configReducer.featureStatus,
    isInitialView: state.optionsReducer.isInitialView
});
export default withRouter(connect(mapStateToProps)(HeatMap));



// WEBPACK FOOTER //
// ./src/components/HeatMap.js